import classes from './PriceSlider.module.scss'
import ReactSlider from 'react-slider';

export const PriceSlider = ({ min, max, value, onAfterChange }) => {

    const Track = (props, state) => <div
        {...props}
        className={classes.sliderTrack}
        style={{ background: `${state.index === 2 ? '#f2f2f2' : state.index === 1 ? '#bfbfbf' : '#f2f2f2'}`, ...props.style }}
    />

    return (
        <ReactSlider
            value={value}
            min={min}
            max={max}
            onAfterChange={onAfterChange}
            renderTrack={Track}
            thumbClassName={classes.sliderThumb}
            className={classes.slider}
        />
    )
};